(function () {
    angular.module('app').component('hostDoraemonCommonInpatientHospitalChargesSobSettingsTableComponent', {
        templateUrl: require('/App/host/views/doraemon/common/inpatientHospitalChargesSobSettingsTable/inpatientHospitalChargesSobSettingsTable.component.html'),
        controller: controller,
        controllerAs: 'vm',
        bindings: {
            benefits: '<'
        }
    });

    function controller() {
        var vm = this;
        vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
        vm.hasSobEnhancement = abp.setting.getBoolean('Hms.Feature.SobEnhancement');
    }
})();
